var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.5 4.439c-1.775 0-3.214 1.42-3.214 3.17 0 1.752 1.44 3.172 3.214 3.172s3.214-1.42 3.214-3.171-1.44-3.171-3.214-3.171m-5.686 3.17C6.814 4.513 9.36 2 12.5 2s5.686 2.512 5.686 5.61-2.546 5.61-5.686 5.61-5.686-2.512-5.686-5.61m5.686 8.537a8.43 8.43 0 0 0-6.71 3.327q-.037.046-.068.087l.279.001h13.277q-.03-.042-.067-.088a8.43 8.43 0 0 0-6.711-3.327m-8.683 1.856a10.92 10.92 0 0 1 8.683-4.295c3.544 0 6.688 1.69 8.683 4.295l.03.04c.165.214.354.461.491.703.171.3.304.66.296 1.1-.007.355-.115.68-.243.933a2.2 2.2 0 0 1-.608.754c-.379.293-.787.393-1.13.433-.296.035-.641.035-.968.035H5.949c-.327 0-.672 0-.967-.035-.344-.04-.752-.14-1.13-.433a2.2 2.2 0 0 1-.61-.754A2.2 2.2 0 0 1 3 19.845c-.008-.44.125-.8.296-1.1.137-.242.326-.49.491-.704z",
    clipRule: "evenodd"
  })));
};
export default SvgUser;